module.exports = __webpack_public_path__ + "media/images/homes/Customize_Ordering_Hours-927c19ef2b520ca37126b128d460a7bb.png";